import { render, staticRenderFns } from "./blackAndWhite.vue?vue&type=template&id=663892e6&scoped=true"
import script from "./blackAndWhite.vue?vue&type=script&lang=js"
export * from "./blackAndWhite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663892e6",
  null
  
)

export default component.exports